"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeQueryParam = exports.toQueryParam = void 0;
var toQueryParam = function (key, val) {
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(val));
};
exports.toQueryParam = toQueryParam;
var makeQueryParam = function (key, val) {
    if (typeof val === 'object') {
        return (Object.keys(val)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(function (objKey) { return "".concat(encodeURIComponent(key), ".").concat(objKey, "=").concat(encodeURIComponent(val[objKey])); })
            .join('&'));
    }
    return toQueryParam(key, val);
};
exports.makeQueryParam = makeQueryParam;
//# sourceMappingURL=query.js.map